import cookies from 'js-cookie';

export default class CookieBanner {
  constructor(selector) {
    this._options = {
      acceptButtonSelector: '.js-accept-cookies',
      acceptedCookieName: 'cookieAccepted',
    };
    this._onAcceptButtonClick = this._onAcceptButtonClick.bind(this);

    this._el = document.querySelector(selector);

    if (!this._el) {
      return;
    }

    this._acceptButton = this._el.querySelector(this._options.acceptButtonSelector);

    if (this._acceptButton) {
      this._acceptButton.addEventListener('click', this._onAcceptButtonClick);
    }
  }

  destroy() {
    if (!this._el) {
      return;
    }

    this._acceptButton.removeEventListener('click', this._onAcceptButtonClick);
    this._el.remove();
  }

  _onAcceptButtonClick() {
    this._saveAcceptingFlag();
    this.destroy();
  }

  _saveAcceptingFlag() {
    cookies.set(this._options.acceptedCookieName, '1', {domain: `.${window.location.hostname}`, expires: 365 * 5});
  }
}
